export const styles = {
  container: {
    padding: '30px',
    maxWidth: '900px',
    margin: '0 auto'
  },
  title: {
    fontSize: '2rem',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: '8px',
    background: 'linear-gradient(135deg, #B026FF 0%, #00D4FF 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textTransform: 'uppercase',
    letterSpacing: '2px'
  },
  subtitle: {
    textAlign: 'center',
    color: '#B0BEC5',
    fontSize: '14px',
    marginBottom: '24px'
  },
  message: {
    padding: '12px 16px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: '14px',
    fontWeight: '600'
  },
  form: {
    position: 'relative',
    zIndex: 10,
    background: 'linear-gradient(135deg, rgba(10, 14, 39, 0.9) 0%, rgba(176, 38, 255, 0.3) 100%)',
    padding: '28px',
    borderRadius: '15px',
    border: '1px solid rgba(0, 212, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(10px)'
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '24px'
  },
  loading: {
    color: '#00D4FF',
    textAlign: 'center',
    padding: '20px'
  },
  button: {
    padding: '14px 28px',
    background: 'linear-gradient(135deg, #B026FF 0%, #0066FF 100%)',
    color: '#FFF',
    border: '1px solid #00D4FF',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  smallButton: {
    padding: '10px 16px',
    background: 'rgba(0, 212, 255, 0.2)',
    color: '#00D4FF',
    border: '1px solid rgba(0, 212, 255, 0.5)',
    borderRadius: '8px',
    fontSize: '13px',
    cursor: 'pointer'
  },
  removeBtn: {
    padding: '8px 12px',
    background: 'rgba(176, 38, 255, 0.25)',
    color: '#C77CFF',
    border: '1px solid rgba(176, 38, 255, 0.5)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px'
  },
  moveBtn: {
    padding: '4px 10px',
    background: 'rgba(0, 212, 255, 0.15)',
    color: '#00D4FF',
    border: '1px solid rgba(0, 212, 255, 0.4)',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: 1
  }
};

export const blockStyle = {
  marginBottom: '24px',
  padding: '20px',
  background: 'rgba(10, 14, 39, 0.6)',
  borderRadius: '12px',
  border: '1px solid rgba(0, 212, 255, 0.2)'
};

export const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  color: '#B0BEC5',
  fontWeight: '600',
  fontSize: '12px',
  textTransform: 'uppercase',
  letterSpacing: '1px'
};

export const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: '8px',
  border: '1px solid rgba(0, 212, 255, 0.3)',
  background: 'rgba(10, 14, 39, 0.8)',
  color: '#E2E8F0',
  fontSize: '14px'
};
